<template>
  <div class="Bottom-new" ref="gkl1">
    <div class="Bottom-box">
      <div class="Bottom-info">
        <div class="Bottom-top">
          <div class="Bottom-logo">
            <img src="../../public/images/logo1.png">
          </div>
          <div class="Bottom-title">
            <span class="text_1">世界至德</span>
            <span class="text_2">GEE TUCK WORLD</span>
          </div>
        </div>

        <div class="Bottom-cent" v-if="info.length>0">

          <div class="Bottom-left">
            <div class="Bottom-conus">联系我们</div>
            <div class="Bottom-conlist">
              <div class="">
                <div class="Bottom-every bot-phone"><span>{{info[0].slug}}</span></div>
                <div class="Bottom-every bot-youj"><span>{{info[1].slug}}</span></div>
                <div class="Bottom-every bot-dizhi"><span>{{info[2].slug}}</span></div>
              </div>
              <div class="">
                <div class="Bottom-txt">{{info[0].value}}</div>
                <div class="Bottom-txt">{{info[1].value}}</div>
                <div class="Bottom-txt">{{info[2].value}}</div>
              </div>
            </div>
          </div>

          <div class="Bottom-right">
            <div class="Bottom-text">
              <img :src="$uploadUrl+info[4].value">
              <div class="">扫一扫关注公众号</div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="Bottom-copyright" v-if="info.length>0">{{info[3].slug}}-{{info[3].value}}</div>
  </div>
  
</template>

<script>
  export default {
    name: 'BotTom',
    data(){
      return{
        info:[],
      }
    },
    created(){
      this.$http.get('index').then((res)=>{
        if(res.data.code == 200){
          this.info = res.data.data.info;
        }else{
          this.$layer.msg(res.data.msg);
        }
      })
    },
    methods: {},
  }
</script>

<style scoped>
  .Bottom-box{
    min-width: 1200px;
    background: #333;
    padding: 40px 0;
  }
  .Bottom-info{
    display: flex;
    width: 1200px;
    margin: 0 auto;
  }
  .Bottom-top{
    width: 150px;
    text-align: center;
  }
  .Bottom-logo{
    width: 58px;
    height: 64px;
    margin: 0 auto;
  }
  .Bottom-logo img{
    width: 58px;
    height: 64px;
  }
  .text_1 {
    display: block;
    font-weight: bold;
    font-size: 32px;
    color: #FFFFFF;
    margin-top: 10px;
  }
  .text_2 {
    display: block;
    font-family: ArialMT;
    font-size: 12px;
    color: #999999;
  }
  .Bottom-cent{
    width: 1000px;
    margin-left: 83px;
    display: flex;
    border-left: 1px solid #7A7A7A;
    padding-left: 74px;
  }
  
  .Bottom-left{
    flex: 1;
    padding-right: 40px;
    
  }
  .Bottom-right{
    width: 130px;
    padding-left: 40px;
    text-align: center;
  }
  .Bottom-text{
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    line-height: 26px;
    margin-top: 10px;
  }
  .Bottom-text img{
    width: 130px;
    height: 130px;
  }
  .Bottom-conus{
    font-size: 24px;
    font-family: Arial-BoldMT, Arial;
    color: #FFFFFF;
    margin-bottom: 20px;
  }
  .Bottom-conlist{
    display: flex;
    align-items: center;
  }
  .Bottom-every{
    font-family: MicrosoftYaHei;
    color: #fff;
    line-height: 40px;
    padding-left: 45px;
  }
  .Bottom-every span{
    display: inline-block;
    font-size: 16px;
    color: #999;
    margin-right: 20px;
  }
  .Bottom-txt{
    font-family: MicrosoftYaHei;
    color: #fff;
    line-height: 40px;
  }
  .bot-phone{
    background: url(../../public/images/phone.png) left center no-repeat;
    background-size: 24px 24px;
  }
  .bot-youj{
    background: url(../../public/images/youjian.png) left center no-repeat;
    background-size: 24px 24px;
  }
  .bot-dizhi{
    background: url(../../public/images/dizhi.png) left center no-repeat;
    background-size: 24px 24px;
  }

  .Bottom-copyright{
    min-width: 1200px;
    line-height: 50px;
    background: #282828;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #999;
    text-align: center;
  }
</style>
